import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Forklift = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 22H24V5C24 4.448 23.552 4 23 4C22.448 4 22 4.448 22 5V19.003C21.418 18.565 20.738 18.251 20 18.101V15C20 14.869 19.974 14.743 19.928 14.629L16.431 5.886C15.973 4.74 14.879 4 13.645 4H10.999C9.34502 4 7.99902 5.346 7.99902 7V10H6.99902C5.34502 10 3.99902 11.346 3.99902 13V24C3.99902 26.206 5.79302 28 7.99902 28C10.205 28 11.999 26.206 11.999 24H14.1C14.565 26.279 16.585 28 18.999 28C21.413 28 23.434 26.279 23.898 24H26.999C27.551 24 27.999 23.552 27.999 23C27.999 22.448 27.551 22 26.999 22H27ZM11 6H13.646C14.057 6 14.422 6.247 14.575 6.628L17.523 14H13.828C13.561 14 13.31 13.896 13.121 13.707L10.293 10.879C10.2 10.786 10.102 10.701 10 10.622V7C10 6.449 10.449 6 11 6V6ZM8.00002 26C6.89702 26 6.00002 25.103 6.00002 24C6.00002 22.897 6.89702 22 8.00002 22C9.10302 22 10 22.897 10 24C10 25.103 9.10302 26 8.00002 26ZM14.101 22H11.462C10.769 20.806 9.47702 20 8.00002 20C7.27202 20 6.58902 20.197 6.00002 20.538V13C6.00002 12.449 6.44902 12 7.00002 12H8.17202C8.43902 12 8.69002 12.104 8.87902 12.293L11.707 15.121C12.274 15.688 13.027 16 13.828 16H18V18.101C16.044 18.5 14.499 20.044 14.101 22V22ZM19 26C17.346 26 16 24.654 16 23C16 21.346 17.346 20 19 20C20.654 20 22 21.346 22 23C22 24.654 20.654 26 19 26Z" />
	</svg>
);

export default Forklift;
